// Lib
import { createSelector } from 'reselect';

export const getCandidatesWithStages = createSelector(
  (state: any) => state.userCandidates,
  (state: any) => state.jobBoard,
  (userCandidates, jobBoard) => {
    const stages = jobBoard.stages.map((stage: any) => ({
      ...stage,
      candidates: userCandidates.filter((candidate: any) => candidate.stageId === stage.id),
    }));

    return { loading: jobBoard.loading, stages };
  }
);

export default {
  getCandidatesWithStages,
};
